import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-xl-11 col-xxl-9" }
const _hoisted_3 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light me-1" }, "delete", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col mb-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "col-md-8" }
const _hoisted_15 = { class: "d-inline-block mt-3 pt-4 border-top border-2 border-light" }
const _hoisted_16 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_i18n_input_text = _resolveComponent("i18n-input-text")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_i18n_input_text_editor = _resolveComponent("i18n-input-text-editor")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BaseTitle, {
            title: _ctx.$t('teamMember'),
            "back-route": {name: 'team-members'},
            "help-text": '<p>' + _ctx.$t('descriptionTeamMembersDetail') + '</p><p>' + _ctx.$t('publishedTextTeam') + '</p><p>' + _ctx.$t('sortWeightDescriptionTeam') + '</p>'
          }, {
            buttons: _withCtx(() => [
              (_ctx.mode === _ctx.PageDetailModeEnum.EDIT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("button", {
                      class: "btn btn-hover icon-link link-danger",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteMember && _ctx.deleteMember(...args)), ["prevent"]))
                    }, [
                      _hoisted_4,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('delete')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title", "help-text"]),
          _createVNode(_component_alert_error, {
            exceptions: _ctx.exceptions,
            class: "mt-3"
          }, null, 8, ["exceptions"]),
          (!_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_dp_form, {
                key: 1,
                as: "form",
                onSubmit: _ctx.submitData,
                novalidate: ""
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_MultilingualSwitcher, {
                    errors: errors,
                    "active-language": _ctx.activeLanguage,
                    onUpdateActiveLanguage: _cache[1] || (_cache[1] = (newValue) => _ctx.activeLanguage = newValue)
                  }, null, 8, ["errors", "active-language"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_input_text, {
                            label: _ctx.$t('firstName'),
                            placeholder: "firstName",
                            name: "firstName",
                            modelValue: _ctx.teamMember.first_name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teamMember.first_name) = $event)),
                            rules: "max:50",
                            errors: errors
                          }, null, 8, ["label", "modelValue", "errors"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_input_text, {
                            label: _ctx.$t('lastName'),
                            placeholder: "lastName",
                            name: "lastName",
                            modelValue: _ctx.teamMember.last_name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teamMember.last_name) = $event)),
                            rules: "max:50",
                            errors: errors
                          }, null, 8, ["label", "modelValue", "errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_i18n_input_text, {
                            data: _ctx.teamMember.function_title,
                            "active-language": _ctx.activeLanguage,
                            label: _ctx.$t('function'),
                            errors: errors,
                            rules: "max:100",
                            name: "function_title"
                          }, null, 8, ["data", "active-language", "label", "errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_input_image, {
                            modelValue: _ctx.teamMember.image_key,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teamMember.image_key) = $event)),
                            module: _ctx.DpModuleEnum.CMS,
                            label: _ctx.$t('image'),
                            "type-code": _ctx.docType
                          }, null, 8, ["modelValue", "module", "label", "type-code"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_i18n_input_text_editor, {
                            data: _ctx.teamMember.content,
                            label: _ctx.$t('content'),
                            "active-language": _ctx.activeLanguage,
                            errors: errors,
                            name: "content",
                            "null-when-empty": ""
                          }, null, 8, ["data", "label", "active-language", "errors"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.mode !== _ctx.PageDetailModeEnum.NEW)
                      ? (_openBlock(), _createBlock(_component_input_number, {
                          key: 0,
                          label: _ctx.$t('sortWeight'),
                          placeholder: "sortWeight",
                          name: "sortWeight",
                          modelValue: _ctx.teamMember.sort_weight,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.teamMember.sort_weight) = $event)),
                          errors: errors
                        }, null, 8, ["label", "modelValue", "errors"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_input_select, {
                      class: "fw-bold",
                      name: "statusCode",
                      selectText: _ctx.$t('selectText'),
                      modelValue: _ctx.teamMember.status_code,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.teamMember.status_code) = $event)),
                      options: _ctx.statusOptions,
                      rules: "required",
                      errors: errors
                    }, null, 8, ["selectText", "modelValue", "options", "errors"]),
                    _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('save')), 1),
                    _createVNode(_component_router_link, {
                      class: "ms-3 btn btn-outline-primary",
                      to: {name: 'team-members'}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}